<div class="drag-area"
  [ngClass]="{disabled: isDisabled()}">
  <div *ngIf="!isError && !isProgress">
    <div>
      <div class="upload-container-content">
        <i [ngClass]="[icon]"></i>
        <span class="upload-text"
          id="upload-text"
          [tabindex]="isDisabled() ? -1 : 0"
          [attr.aria-disabled]="isDisabled()"
          [innerHTML]="text"></span>
      </div>
      @if (showConsentCheckbox) {
      <div class="checkbox-container">
        <app-vi-upload-consent [disabled]="false"
          [isUserConfirmTerms]="approvedConsent"
          (toggleFunc)="toggleConfirmTerms()">
        </app-vi-upload-consent>
      </div>
      }
    </div>
    <input #fileInput
      type="file"
      mode="basic"
      name="filesList"
      class="add-files-input"
      [disabled]="isDisabled()"
      [accept]="filesType"
      [multiple]="isMultiple"
      [maxFileSize]="maxSize"
      aria-labelledby="upload-text"
      onerror="onError($event)"
      (change)="onSelect($event)" />
  </div>
  <!-- loader he loading the files -->
  <mat-progress-bar *ngIf="isProgress && !isError"
    mode="indeterminate"></mat-progress-bar>

  <!-- Error in case of upload failed -->
  <div class="upload-error"
    [attr.aria-live]="true"
    *ngIf="isError && !isProgress">
    {{ resources.UploadContainerUploadFilesError }}
  </div>
</div>